// extracted by mini-css-extract-plugin
export var container = "_s8-0";
export var inputWidth = "_s8-1";